/* eslint-disable max-len */
import { order, shippingValueSort } from './deliveryListOrder';
import { validationValue } from './strings';

export const getMethodPayment = (labelMethod) => {
  if (labelMethod === 'availableBalance') return 101;
  if (labelMethod === 'availableCredit') return 105;
  if (labelMethod === 'deductFromCollection') return 102;
  return null;
};

export const sortListDelivery = (list, criterion, direction) => {
  if (direction === 'asc') {
    return order(list, criterion, 'asc');
  }
  if (direction === 'desc') {
    return order(list, criterion, 'desc');
  }
  if (criterion === 'shippingValue' && direction === 'shippingValueSortDesc') {
    return shippingValueSort(list, 'desc');
  }
  if (criterion === 'shippingValue' && direction === 'shippingValueSortAsc') {
    return shippingValueSort(list, 'asc');
  }
  return list;
};

export const selectTitleToStep = (step) => {
  switch (step) {
    case 1: return ('Ruta de envío');
    case 2: return ('¿Cuánto mide tu envío?');
    case 3: return ('Así vamos hasta ahora');
    case 4: return ('Últimos detalles');
    default: return ('');
  }
};

export const allFieldsFilled = (fields, errorsList) => {
  const filledCompleted = Object.values(fields).every((value) => value) && !errorsList.length;
  const emailValid = validationValue(fields.emailForBilling, 'email').correct;

  if (fields.emailForBilling) {
    return filledCompleted && emailValid;
  }
  return filledCompleted;
};

export const validationsFilledInputs = (fields, errorsList) => {
  const emailValid = validationValue(fields.emailForBilling, 'email').correct;
  const {
    name, tradeName, codeVerification, locationCode, ...otherFields
  } = fields;

  const allFilled = Object.values(otherFields)?.every((value) => value) && !errorsList?.length;

  const juridicaTaxRegimeRequired = fields.personType === 'Persona Jurídica' && !(tradeName && codeVerification);

  const naturalBusinessNameRequired = fields.personType === 'Persona Natural' && !name;

  const isValidationRequired = allFilled && (juridicaTaxRegimeRequired || naturalBusinessNameRequired);

  if (emailValid && isValidationRequired) {
    return false;
  }

  if (isValidationRequired) {
    return false;
  }

  return allFilled;
};

export const colorButton = (code) => (code === '170' ? 'primary' : 'primary-mx');

export const limitCharacters = (name, value, maxValue, updateFormValues) => {
  const limitValue = value.toString();
  return updateFormValues(name, limitValue.slice(0, maxValue));
};
